import videojs from "video.js";

const videoEmbeds = document.querySelectorAll(".video-embed");
if (videoEmbeds != null && videoEmbeds.length > 0) {
    videoEmbeds.forEach((videoEmbed) => {
        const video = videoEmbed.querySelector("video");
        const player = videojs(video, { autoplay: false });
        player.ready(deviceRotation)
        window.addEventListener('loadedmetadata', deviceRotation);
        window.addEventListener("resize", deviceRotation);

        function deviceRotation() {
            let vw = 930;
            if(window.innerWidth < 576){
                vw = window.innerWidth - 30;
            }else if(window.innerWidth < 768){
                vw = 510;
            }else if(window.innerWidth < 992){
                vw = 690;
            }
            const vh = vw * 0.5625;
            videoScale(vw, vh);
        }

        function videoScale(vw, vh) {
            const screen = videoEmbed.querySelector(".video-js");
            screen.style.height = `${vh}px`;
            screen.style.width = `${vw}px`;
        }
    })

}